export default __webpack_public_path__ + "static/media/thumb_16.1644403b.webp";